import { ButtonBase, Typography } from '@material-ui/core'
import React from 'react'

import { persianRegex } from '../../helpers/regex'
import { getRoleFromStorage } from '../../helpers/userData'
import { LocalizedLink } from '../../routes/localizedRoutes'
import channelPagesRoleManagement from '../../staticRoleManagement/channelPagesRoleManagement'
import { Channel } from '../../types/channel'
import useStyles from './styles/ChannelsTable.styles'

interface ChannelRowProps {
  data: Channel
}

const ChannelRow: React.FC<ChannelRowProps> = ({ data }) => {
  const classes = useStyles()

  const {
    basicDetails: {
      name,
      channelCode,
      displayChannelCode,
      channelType,
      channelID
    }
  } = data

  const isPersian = persianRegex.test(name)

  const disableRow = channelPagesRoleManagement
    .find((item) => item.route === '/channels/:id/:channelCode/:page')
    ?.rolesListWithReadAccess?.includes(getRoleFromStorage())

  return (
    <ButtonBase
      className={classes.tableRow}
      disabled={!disableRow}
      component={LocalizedLink}
      to={`/channels/${channelID}/${channelCode}/details`}>
      <div className={classes.nameCell}>
        <Typography
          variant="h4"
          style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
          {name}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{displayChannelCode}</Typography>
      </div>
      <div>
        <Typography variant="body1">{channelType}</Typography>
      </div>
    </ButtonBase>
  )
}

export default ChannelRow
